import React from "react";
import "../styles/general.scss";
import PropTypes from 'prop-types';

class LandingPage extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount()
    {}

    render()
    {
        return (
            <div
                style={{
                width: "100%",
                height: "100vh",
                overflow: "hidden"
            }}>
                <div
                    style={{
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "flex-start",
                    backgroundImage: `url('data:image/png;base64, ${this.props.backgroundImage}')`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    position: "absolute",
                    backgroundPosition: "bottom",
                    zIndex: -1
                }}/>
                <div
                    style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <img
                        style={{
                        position: "absolute",
                        height: "100vh",
                        justifySelf: "center"
                    }}
                        alt="Content"
                        src={`data:image/png;base64, ${this.props.contentImage}`}/>
                    <div
                        style={{
                        borderRadius: "5em",
                        height: "50vh",
                        display: "flex",
                        alignContent: "center",
                        position: "absolute",
                        bottom: 0
                    }}><img
                        id="poster"
                        onClick={this.props.buttonFunc}
                        style={{
                height: "10vh",
                placeSelf: "center",
                paddingBottom: "5vh"
            }}
                        alt="Button"
                        src={`data:image/png;base64, ${this.props.buttonImage}`}/></div>
                </div>
                <img
                    src={`data:image/png;base64, ${this.props.titleImage}`}
                    alt={"Title"}
                    style={{
                    zIndex: 10,
                    position: "absolute",
                    right: "2.5vw",
                    top: 0,
                    maxHeight: "15vh",
                    maxWidth: "30vw"
                }}/>
            </div>
        );
    }
}

LandingPage.propTypes = {
    backgroundImage: PropTypes.string,
    titleImage: PropTypes.string,
    contentImage: PropTypes.string,
    buttonImage: PropTypes.string,
    buttonFunc: PropTypes.func,
    startGameFunc: PropTypes.func
};

LandingPage.defaultProps = {
    backgroundImage: "",
    titleImage: "",
    contentImage: "",
    buttonImage: "",
    buttonFunc: function () {
        console.log("Pressed button");
    },
    startGameFunc: function () {
        console.log("startGameFunc");
    }
};

export default LandingPage;